/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

// BROWSER POLYFILLS

// Zone JS is required by default for Angular itself.
import "zone.js"; // Included with Angular CLI.

// Zone JS patch for ResizeObserver API
import "zone.js/plugins/zone-patch-resize-observer";
import { ObgAppStartup } from "@obg/ngx.core";
// Node process polyfills which are required by diffusion
import { Buffer } from "buffer";
import * as process from "process";

/** fix angular 6 animation issue in Edge **/
if (!Element.prototype.matches && (Element.prototype as any).msMatchesSelector) {
	Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}

(window as any).Buffer = Buffer;
(window as any).process = process;

declare const window: {
	obgStartup?: ObgAppStartup;
	ngDevMode: boolean;
};
if (window.obgStartup?.config?.appSettings.isDebug !== true) {
	// enableProdMode doesn't work
	// the same file sets the value and freezes it before we can set it with enableProdMode :)
	window.ngDevMode = false;
}
